export default "__VITE_ASSET__BVxrOhbE__"